import setActTeams from './setActTeams';
import setActTeam from './setActTeam';
import resetPagination from './resetPagination';
import setAvailableActTeams from './setAvailableActTeams';
import setAllActTeams from './setAllActTeams';
import resetActTeamStore from './resetActTeamStore';

export default {
  setActTeams,
  setActTeam,
  resetPagination,
  setAvailableActTeams,
  setAllActTeams,
  resetActTeamStore,
};
